var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('head-layout',{attrs:{"title":"Webhooks"}}),_vm._v(" "),_c('div',{staticClass:"text-h2"},[_vm._v("Webhooks")]),_vm._v(" "),_c('v-data-table',{attrs:{"items":_vm.hooks,"headers":_vm.headers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }